<template>
  <BaseModal
    v-if="scheduledPriceUpdate"
    :heading="$t('services.price_update.scheduled_price_update_heading')"
    :details="[
      {
        label: $t('services.price_update.scheduled_for'),
        value: filters.dateTime(scheduledPriceUpdate.scheduledAt),
      },
      {
        label: $t('global.items.service', 2),
        value: scheduledPriceUpdate?.servicePriceChanges?.length
      },
      {
        label: $t('services.price_update.average_price_change'),
        value: `${Math.round((scheduledPriceUpdate.servicePriceChanges?.reduce((acc, change) => acc + ((change.newPrice - change.originalPrice) / change.originalPrice), 0) / scheduledPriceUpdate?.servicePriceChanges?.length) * 10000) / 100}%`
      }
    ]"
    :actions="[
      {
        name: 'edit',
        label: $t('global.actions.edit'),
        icon: 'edit',
      },
      {
        name: 'cancel',
        label: $t('global.actions.cancel'),
        icon: 'delete',
      }
    ]"
    :parentRoute="parentRouteName ? {
      name: parentRouteName
    } : undefined"
    :loading="!scheduledPriceUpdate?.servicePriceChanges"
    @action="onAction"
    @close="emit('close')"
    testId="view-price-change"
  >
    <BaseTable
      :headers="[$t('global.name'), {
          value: $t('services.price_update.current_price'),
          alignRight: true
        }, {
          value: $t('services.price_update.new_price'),
          alignRight: true
        }]"
      :rows="scheduledPriceUpdate.servicePriceChanges?.map((change) => ({
            id: change.id,
            cells: [flattenedServices.find(s => s.id === change.service.id)?.name || '', {value: filters.currency(change.originalPrice), alignRight: true}, {value: filters.currency(change.newPrice), alignRight: true}]
          })) || []"
      v-test="'service-price-update-list'"
    />
  </BaseModal>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import filters from '@/filters';
import { useServiceGroupsStore } from '@/stores/service-groups';
import { useServicesPriceScheduleStore } from '@/stores/services-price-schedule';

const props = defineProps<{
  parentRouteName?: string;
}>();

const { cancelScheduledPriceUpdate } = useServicesPriceScheduleStore();
const { scheduledPriceUpdate, scheduleFetched } = storeToRefs(
  useServicesPriceScheduleStore(),
);
const { flattenedServices } = storeToRefs(useServiceGroupsStore());

const router = useRouter();
const onAction = (action: string) => {
  if (action === 'cancel') {
    cancelScheduledPriceUpdate().then(() => {
      router.push({ name: props.parentRouteName });
    });
  } else if (action === 'edit') {
    router.push({ name: 'admin-service-edit-price-update' });
  }
};

watch(
  scheduleFetched,
  () => {
    if (
      scheduleFetched.value &&
      !scheduledPriceUpdate.value &&
      props.parentRouteName
    ) {
      router.push({ name: props.parentRouteName });
    }
  },
  {
    immediate: true,
  },
);
</script>
